import { useLayoutEffect } from 'react';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { SUB_NAV_WIDTH } from 'src/constants';

import { MiniSidebarProps } from './MiniSidebar.interface';
import {
  FixedWrapper,
  Menu,
  MenuIcon,
  MenuItem,
  Wrapper,
} from './MiniSidebar.styled';

export const MiniSidebar = (props: MiniSidebarProps) => {
  // A second fixed-position rail beside the main Sidebar. Publish its width so anything
  // else fixed to the viewport (e.g. the canary banner) can inset past both rails.
  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      '--secondary-rail-width',
      `${SUB_NAV_WIDTH}px`,
    );

    return () => {
      document.documentElement.style.setProperty(
        '--secondary-rail-width',
        '0px',
      );
    };
  }, []);

  return (
    <Wrapper>
      <FixedWrapper>
        <Menu>
          {props.items.map((item, index) => (
            <MenuItem
              key={index}
              $isSelected={item.isSelected}
              $disabledHighlightIconColor={item.disabledHighlightIconColor}>
              <CustomTooltip
                title={item.tooltipMessage}
                isSecondaryTooltip={item.secondaryTooltip}
                skipValidateOverflow={true}>
                <span style={{ display: 'inline-flex' }}>
                  <MenuIcon
                    disableRipple
                    disabled={item.disabled}
                    onClick={item.onClick}>
                    {item.icon}
                  </MenuIcon>
                </span>
              </CustomTooltip>
            </MenuItem>
          ))}
        </Menu>
      </FixedWrapper>
    </Wrapper>
  );
};
